import { Typography } from "@mui/material/index";
import { Stack } from "@mui/material/index";
import { ISubtitle } from "./types";
import { useTranslation } from "react-i18next";

const RenderedSubtitle = ({subtitle}: ISubtitle) => {
    const {t} = useTranslation(['network', 'translation']);

    return (
        <Stack direction="row" alignItems="center" columnGap={3}>
            {subtitle.map(({title, value}) => (
                <Stack direction="row" alignItems="end" columnGap={1}>
                    <Typography variant="bodyLarge">{t(title)}:</Typography>
                    <Typography variant="bodyLarge">{value}</Typography>
                </Stack>
            ))}
        </Stack>
    )
}

export default RenderedSubtitle;
